import { DefaultTheme } from '../theme';

const HANDLE_SIZE = 5;

export const CSS = {
	handle: 'c-ResizeHandle',
	handleX: 'c-ResizeHandle--x',
	handleY: 'c-ResizeHandle--y',
	bodyDraggingX: 'c-ResizeHandle__bodyDragging--x',
	bodyDraggingY: 'c-ResizeHandle__bodyDragging--y',
};

// On `body`, not the divider: the pointer is tracked on `window` and routinely leaves the 5px hit area.
const bodyDragging = {
	'user-select': 'none',
};

export const Style = {
	[CSS.handle]: {
		flex: `0 0 ${HANDLE_SIZE}px`,
		'background-color': DefaultTheme.font.color.divider,
		'&:hover': {
			'background-color': DefaultTheme.color.accent,
		},
		'&:focus': {
			outline: 'none',
			'background-color': DefaultTheme.color.accent,
		},
	},
	[CSS.handleX]: {
		cursor: 'col-resize',
	},
	[CSS.handleY]: {
		cursor: 'row-resize',
	},
	[CSS.bodyDraggingX]: {
		...bodyDragging,
		cursor: 'col-resize !important',
	},
	[CSS.bodyDraggingY]: {
		...bodyDragging,
		cursor: 'row-resize !important',
	},
};
